import React from 'react'
import Modal from 'react-modal'
import update from 'immutability-helper'
import DropzoneComponent from 'react-dropzone-component';
import PaymentRecurringSelect from '../../helpers/General/PaymentRecurringSelect'
import UnitedStatesSelect from '../../helpers/General/UnitedStatesSelect';
import OwnersSelect from '../../helpers/Owner/OwnersSelect';
import FeesSelect from '../../helpers/Fees/FeesSelect';
import BankAccountSelect from '../../helpers/BankAccounts/BankAccountSelect'
import { browserHistory } from 'react-router';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import NavLink from '../Routes/NavLink'
import { InstantVerification, SelectableCard } from '../../helpers/Cards/SelectableCard';

import { property } from '../../core/controllers/Property';
import { dropZone } from '../../core/utilities/DropZoneHandler';
import { modal } from '../../core/utilities/modal'
import { documents } from '../../core/controllers/Documents';
import { modalStyles } from '../../core/controllers/ModalStyles';
import { user } from '../../core/controllers/user';

// #  TODO move this to seperate component
const Attachment = ({attachment, deleteFunc}) => {
    return (
        <attachment key={attachment.storage_id}>
            <div class={attachment.content_type == 'pdf' ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xs-12" : "col-lg-3 col-md-3 col-sm-4 col-xs-6 col-xs-6"}>
                <span class="deleteDocument" onClick={deleteFunc.bind(this, attachment)}><i class="pe-7s-close"></i></span>
                <a href={attachment.url} target="_blank">
                    { attachment.content_type == 'pdf' ? (
                        <object width="100%" height="500" data={attachment.url} type="application/pdf"></object>
                    ) : (
                        <img src={attachment.url} width="100px" height="100px" />
                    )}
                </a>
            </div>
        </attachment>
    );
};

export default class PropertyEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            propertyId : props.propertyId,
            image: null,
            sortID: null,
            property: {
                property_type: 0,
                name: '',
                address: '',
                city: '',
                state: '',
                zipcode: '',
                qb_custom_ref_id: '',
                owner_id: 0,
                fee_id: 0,
                bank_identifier: 0,
                bath: '1 Bath',
                bed: '1 Bedroom',
                sqft: ''
            },
            feeDetails: null,
            singleUnit: true,
            totalUnits: [],
            newUnit: false,
            hasChangedUnit: false,
            showModal: false,
            unitData : {
                property_unit_id: 0,
                unit_name: '',
                sqft: '',
                bed: '',
                bath: '',
                lease: '',
                contract_id: 0
            },
        };
    }

    componentDidMount() {
        var self = this;
        if(!this.props.newProp){
            property.getProperty(this.props.propertyId, function(response) {
                const details = response.data.details;
                const bank_account = response.data.bank_account;
                var singleUnit = true;
                var property = {
                    property_type: details.property_type,
                    name: details.property_name,
                    address: details.property_address,
                    city: details.property_city,
                    state: details.property_state,
                    zipcode: details.property_zip,
                    qb_custom_ref_id: details.qb_custom_ref_id,
                    owner_id: details.owner_id,
                    fee_id: details.fee_id,
                    bath: details.bath,
                    bed: details.bed,
                    sqft: details.sqft,
                    bank_identifier: bank_account ? bank_account.bank_identifier : 0
                };

                var formattedUnited = [];
                if (response.data.units_tally > 0) {
                    const units = response.data.units;
                    formattedUnited = units.map((item, key) => {
                        return item;
                    });
                    singleUnit = false;
                }
                self.setState({
                    property: property,
                    image: response.data.photo,
                    totalUnits: formattedUnited,
                    singleUnit: singleUnit,
                    feeDetails: response.data.fee,
                })
            });
        }

        dropZone.setup(this, 'propertyimage', this.state.propertyId);
    }

    triggerUpload(id) {
        var self = this;
        if(id != 0) {
            dropZone.setup(this, 'propertyimage', id, true);
        }

        if(dropZone.dropZone.files.length > 0) {
            dropZone.upload(function() {
                if(self.props.newProp) {
                    browserHistory.goBack();
                } else {
                    property.getProperty(self.props.propertyId, function(response) {
                        const details = response.data.details;
                        const bank_account = response.data.bank_account;
                        var singleUnit = true;
                        var property = {
                            property_type: details.property_type,
                            name: details.property_name,
                            address: details.property_address,
                            city: details.property_city,
                            state: details.property_state,
                            zipcode: details.property_zip,
                            qb_custom_ref_id: details.qb_custom_ref_id,
                            owner_id: details.owner_id,
                            fee_id: details.fee_id,
                            bath: details.bath,
                            bed: details.bed,
                            sqft: details.sqft,
                            bank_identifier: bank_account ? bank_account.bank_identifier : 0
                        };

                        var formattedUnited = [];
                        if (response.data.units_tally > 0) {
                            const units = response.data.units;
                            formattedUnited = units.map((item, key) => {
                                return item;
                            });
                            singleUnit = false;
                        }
                        self.setState({
                            property: property,
                            image: response.data.photo,
                            totalUnits: formattedUnited,
                            singleUnit: singleUnit,
                            feeDetails: response.data.fee
                        })
                    });
                }
            });
        } else {
            if(self.props.newProp) {
                browserHistory.goBack();
            } else {
                property.getProperty(self.props.propertyId, function(response) {
                    const details = response.data.details;
                    const bank_account = response.data.bank_account;
                    var singleUnit = true;
                    var property = {
                        property_type: details.property_type,
                        name: details.property_name,
                        address: details.property_address,
                        city: details.property_city,
                        state: details.property_state,
                        zipcode: details.property_zip,
                        qb_custom_ref_id: details.qb_custom_ref_id,
                        owner_id: details.owner_id,
                        fee_id: details.fee_id,
                        bath: details.bath,
                        bed: details.bed,
                        sqft: details.sqft,
                        bank_identifier: bank_account ? bank_account.bank_identifier : 0
                    };
                    var formattedUnited = [];
                    if (response.data.units_tally > 0) {
                        const units = response.data.units;
                        formattedUnited = units.map((item, key) => {
                            return item;
                        });
                        singleUnit = false;
                    }
                    self.setState({
                        property: property,
                        image: response.data.photo,
                        totalUnits: formattedUnited,
                        singleUnit: singleUnit,
                        feeDetails: response.data.fee
                    })
                });
            }
        }
    }

    validate() {
        const enteredData = this.state.property;
        const title = enteredData.name;
        const propertyType = enteredData.property_type;
        const address = enteredData.address;
        const city = enteredData.city;
        const state = enteredData.state;
        const zipcode = enteredData.zipcode;

        if(title === undefined || title.length == 0) {
            modal.showInfo("You need to provide a title for this property.", "danger", "top", "center");
            return false;
        }

        if(propertyType == "0" || propertyType == 0) {
            modal.showInfo("What type of property is this?", "danger", "top", "center");
            return false;
        }

        if(address == "" || address.length == 0) {
            modal.showInfo("Specify the address.", "danger", "top", "center");
            return false;
        }

        if(city == "" || city.length == 0) {
            modal.showInfo("Specify the city.", "danger", "top", "center");
            return false;
        }

        if(state == "" || state.length == 0) {
            modal.showInfo("Specify the state.", "danger", "top", "center");
            return false;
        }

        if(zipcode == "" || zipcode.length == 0) {
            modal.showInfo("Specify the zipcode.", "danger", "top", "center");
            return false;
        }

        return true;
    }

    handleSavePropertyData(e){
        if(!this.validate()) {
            return;
        }

        var self = this;
        property.saveProperty(this.state, function(response) {
            self.triggerUpload(response.data.property_id);
            modal.showInfo("Property added!", "success", "top", "center");
        });
    }

    deleteProperty(e){
        property.deleteProperty(this.state.propertyId, function(response) {
            browserHistory.goBack();
            modal.showInfo("Property deleted!", "success", "top", "center");
        });
    }

    updateProperty(e){
        var self = this;
        property.updateProperty(this.state, function(response) {
            self.triggerUpload(response.data.property_id);
            modal.showInfo("Property updated!", "success", "top", "center");
        });
    }

    handleDeleteDocument(attachment) {
        var self = this;
        documents.deleteDocument(attachment.storage_id, function() {
            property.getProperty(self.props.propertyId, function(response) {
                const details = response.data.details;
                const bank_account = response.data.bank_account;
                var singleUnit = true;
                var property = {
                    property_type: details.property_type,
                    name: details.property_name,
                    address: details.property_address,
                    city: details.property_city,
                    state: details.property_state,
                    zipcode: details.property_zip,
                    qb_custom_ref_id: details.qb_custom_ref_id,
                    owner_id: details.owner_id,
                    fee_id: details.fee_id,
                    bath: details.bath,
                    bed: details.bed,
                    sqft: details.sqft,
                    bank_identifier: bank_account ? bank_account.bank_identifier : 0
                };
                var formattedUnited = [];
                if (response.data.units_tally > 0) {
                    const units = response.data.units;
                    formattedUnited = units.map((item, key) => {
                        return item;
                    });
                    singleUnit = false;
                }
                self.setState({
                    property: property,
                    image: response.data.photo,
                    totalUnits: formattedUnited,
                    singleUnit: singleUnit,
                    feeDetails: response.data.fee
                })
            });
        });
    }

    handleTitleChange(e){
        this.setState({
            property: update(this.state.property, {
                name: {$set: e.target.value
                }}
            )
        });
    }

    onPropertyTypeChange(e) {
        this.setState({
            property: update(this.state.property, {
                property_type: {$set: e.target.value
                }}
            )
        });
    }

    handleAddressChange(e) {
        this.setState({
            property: update(this.state.property, {
                address: {$set: e.target.value
                }}
            )
        });
    }

    handleCityChange(e) {
        this.setState({
            property: update(this.state.property, {
                city: {$set: e.target.value
                }}
            )
        });
    }

    handleStateChange(e) {
        this.setState({
            property: update(this.state.property, {
                state: {$set: e.target.value
                }}
            )
        });
    }

    handleOwnerChange(e) {
        this.setState({
            property: update(this.state.property, {
                owner_id: {$set: e.target.value
                }}
            )
        });
    }

    handleFeeChange(e) {
        this.setState({
            property: update(this.state.property, {
                fee_id: {$set: e.target.value
                }}
            )
        });
    }

    handleBankChange(e) {
        this.setState({
            property: update(this.state.property, {
                bank_identifier: {$set: e.target.value
                }}
            )
        });
    }

    handleZipcodeChange(e) {
        this.setState({
            property: update(this.state.property, {
                zipcode: {$set: e.target.value
                }}
            )
        });
    }

    handleSqftChange(e) {
        this.setState ({
            property: update(this.state.property, {
                sqft: {$set: e.target.value},
            })
        });
    }

    handleBedChange(e) {
        this.setState ({
            property: update(this.state.property, {
                bed: {$set: e.target.value},
            })
        });
    }

    handleBathChange(e) {
        this.setState ({
            property: update(this.state.property, {
                bath: {$set: e.target.value},
            })
        });
    }

    multipleUnits(e) {
        this.setState({
            singleUnit: false
        })
    }

    singleUnit(e) {
        this.setState({
            singleUnit: true
        })
    }

    renderAttachment(image) {
        var self = this;
        if (image !== null && image != false) {
            return <Attachment attachment={image} deleteFunc={self.handleDeleteDocument.bind(self)}/>
        }
        else return (<p>No property cover photo found. </p>);
    }

    handleRefIdChange(e){
        this.setState({
            property: update(this.state.property, {
                qb_custom_ref_id: {$set: e.target.value
                }
            })
        })
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    handleOpenModal(value) {
        if (value == "add_unit") {
            this.setState ({
                newUnit: true,
            });
        }
        this.updateUnitData(value);
        this.setState({ showModal: true });
    }

    handleCloseModal() {
        this.setState({
            showModal: false,
        });
        this.refresh();
    }

    handleCreateUnit() {
        if (!this.validateAddUnit()) {
            return;
        }

        const unitData = this.state.unitData;
        var copy = this.state.totalUnits;

        copy.push({
            unit_name: unitData.unit_name,
            sqft: unitData.sqft,
            bed: unitData.bed,
            bath: unitData.bath,
            lease: unitData.lease,
            contract_id: unitData.contract_id
        });
        this.setState({
            totalUnits: copy,
            hasChangedUnit: true,
        });
        this.handleCloseModal();
        modal.showInfo("Unit temporarily added!", "success", "top", "center");
    }

    handleSaveUnit() {
        if (!this.validateAddUnit()) {
            return;
        }

        const totalUnits = this.state.totalUnits;
        const unitData = this.state.unitData;

        var copy = totalUnits.map((item, key) => {
            if (item.property_unit_id == unitData.property_unit_id) {
                item.property_unit_id = unitData.property_unit_id;
                item.unit_name = unitData.unit_name;
                item.sqft = unitData.sqft;
                item.bed = unitData.bed;
                item.bath = unitData.bath;
                item.lease = unitData.lease;
                item.contract_id = unitData.contract_id;
            }
            return item;
        })
        this.setState({
            totalUnits: copy,
            hasChangedUnit: true,
        });
        this.handleCloseModal();
        modal.showInfo("Unit temporarily saved!", "success", "top", "center");
    }

    handleDeleteUnit() {
        const totalUnits = this.state.totalUnits;
        const unitData = this.state.unitData;
        var self = this;
        var copy = totalUnits;

        modal.showDangerModalWithOK("Are you sure?","You are about to delete this unit.", "Yes, Delete");
        jQuery(".move-on").on('click',function() {
            totalUnits.map((item, key) => {
                if (item.id == unitData.property_unit_id) {
                    copy.splice(key, 1);
                }
            })

            self.setState({
                totalUnits: copy,
                hasChangedUnit: true,
            });
            self.handleCloseModal();
            modal.showInfo("Unit temporarily deleted!", "success", "top", "center");
        })
    }

    updateUnitData(value) {
        const totalUnits = this.state.totalUnits;

        if (value == "add_unit") {
            this.refresh();
        } else {
            totalUnits.map((item, key) => {
                if (item.property_unit_id == value) {
                    this.setState ({
                        unitData: update(this.state.unitData, {
                            property_unit_id: {$set: item.property_unit_id},
                            unit_name: {$set: item.unit_name},
                            sqft: {$set: item.sqft},
                            bed: {$set: item.bed},
                            bath: {$set: item.bath},
                            lease: {$set: ''},
                            contract_id: {$set: item.contract_id}
                        })
                    });
                }
            })
        }
    }

    handleUnitNameChange(e) {
        this.setState ({
            unitData: update(this.state.unitData, {
                unit_name: {$set: e.target.value},
            })
        });
    }

    handleUnitSqFootageChange(e) {
        this.setState ({
            unitData: update(this.state.unitData, {
                sqft: {$set: e.target.value},
            })
        });
    }

    handleUnitBedroomsChange(e) {
        this.setState ({
            unitData: update(this.state.unitData, {
                bed: {$set: e.target.value},
            })
        });
    }

    handleUnitBathroomsChange(e) {
        this.setState ({
            unitData: update(this.state.unitData, {
                bath: {$set: e.target.value},
            })
        });
    }

    refresh() {
        this.setState({
            unitData: update(this.state.unitData, {
                property_unit_id: {$set: 0},
                unit_name: {$set: ''},
                sqft: {$set: ''},
                bed: {$set: ''},
                bath: {$set: ''},
                lease: {$set: ''},
                contract_id: {$set: 0},
            })
        });
    }

    validateAddUnit() {
        if (this.state.unitData.unit_name == "") {
            modal.showInfo("You need to provide a name for this unit.", "danger", "top", "center");
            return false;
        }

        return true
    }

    didSelectRow(row) {
        this.refresh();
        this.updateUnitData(row.property_unit_id);
        this.setState({ showModal: true });
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    formatLease(cell, row) {
        if(cell != '0' && cell != null && cell != 0) {
            return (
            <span onClick={this}>
                <NavLink to={"/lease/" + cell}>View Lease</NavLink>
            </span>
            )
        } else {
            return 'No Lease Active';
        }
    }

    render(){
        var self = this;
        const image = this.renderAttachment(this.state.image);
        const newProp = this.props.newProp;
        const propertyName = this.state.property.name;
        const propertyType = this.state.property.property_type;
        const address = this.state.property.address;
        const city = this.state.property.city;
        const state = this.state.property.state;
        const zipcode = this.state.property.zipcode;
        const bed = this.state.property.bed;
        const bath = this.state.property.bath;
        const sqft = this.state.property.sqft;
        const qb_custom_ref_id = this.state.property.qb_custom_ref_id;
        const owner = this.state.property.owner_id;
        const fee = this.state.property.fee_id;
        const bank_identifier = this.state.property.bank_identifier;
        const feeDetails =  this.state.feeDetails;
        const totalUnits = this.state.totalUnits;
        const singleUnit = this.state.singleUnit;
        const newUnit = this.state.newUnit;
        const unitData = this.state.unitData;
        const unitName = unitData.unit_name;
        const unitSqft = unitData.sqft;
        const unitBed = unitData.bed;
        const unitBath = unitData.bath;
        const hasChangedUnit = this.state.hasChangedUnit;
        const options = {
            onRowClick: this.didSelectRow.bind(this)
        };
        const toggleSingleUnit = () => this.setState({ singleUnit: !singleUnit })
        return (
            <div>
            <div class="row blue-bottom-margin">
                <div class="row">
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            {newProp ? (
                            <span class="sub-page-header-title">Add a Property</span>
                            ) : (
                            <span class="sub-page-header-title">{propertyName}</span>
                            )}
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Property Information</h4>
                            <p class="category"></p>
                        </div>
                        <div class="content">
                            <form>
                                <div class="row">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-2 col-sm-0 col-xs-0"></div>
                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                                <SelectableCard selected={ singleUnit }
                                                    onClick={ toggleSingleUnit }
                                                    color="blue"
                                                    iconClass="icon-house-outline"
                                                    title="Single Unit"
                                                    optionCount={2}
                                                />
                                        </div>
                                                <div class="col-md-4 col-sm-6 col-xs-12">
                                                <SelectableCard selected={ !singleUnit }
                                                    onClick={ toggleSingleUnit }
                                                    color="blue"
                                                    iconClass="icon-apartment-filled"
                                                    title="Multiple Units"
                                                    optionCount={2}
                                                />
                                            
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <label for="assignee">Property Name*</label>
                                                <input type="text" value={propertyName} class="form-control tenant-info" name="title" placeholder="Backster building..." id="title" onChange={this.handleTitleChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-md-offset-1">
                                            <div class="form-group">
                                                <label>Property Type*</label>
                                                <select class="form-control" value={propertyType} onChange={this.onPropertyTypeChange.bind(this)}>
                                                    <option value='0'>Select a property type</option>
                                                    <option value='Apartment'>Apartment</option>
                                                    <option value='Single Family Home'>Single Family Home</option>
                                                    <option value='Duplex/Triplex/Townhouse'>Duplex / Triplex / Townhouse</option>
                                                    <option value='Mobile/Manufactured Home'>Mobile / Manufactured Home</option>
                                                    <option value='Dormitory'>Dormitory</option>
                                                    <option value='Commercial'>Commercial</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <label for="address">Address*</label>
                                                <input type="text" class="form-control" value={address} onChange={this.handleAddressChange.bind(this)} placeholder="10000 Marshall Dr." />
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-md-offset-1">
                                            <div class="form-group">
                                                <label for="city">City*</label>
                                                <input type="text" class="form-control" value={city} name="city" onChange={this.handleCityChange.bind(this)} placeholder="Lenexa" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <UnitedStatesSelect columnSize={0} sortID={state} title="State*" onChange={this.handleStateChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-md-offset-1">
                                            <div class="form-group">
                                                <label for="address">Zipcode*</label>
                                                <input type="text" class="form-control" value={zipcode} onChange={this.handleZipcodeChange.bind(this)} placeholder="62472" />
                                            </div>
                                        </div>
                                    </div>
                                    {singleUnit == true && (
                                    <div>
                                        <div class="row">
                                            <div class="col-md-5 col-sm-12 col-xs-12">
                                                <div class="form-group">
                                                    <label for="bedrooms">Beds</label>
                                                    <input type="text" class="form-control" value={bed} name="bedrooms" placeholder="1 Bedroom" onChange={this.handleBedChange.bind(this)}/>
                                                </div>
                                            </div>
                                            <div class="col-md-5 col-md-offset-1 col-sm-12 col-xs-12">
                                                <div class="form-group">
                                                    <label for="bathrooms">Baths</label>
                                                    <input type="text" class="form-control" value={bath} name="bathrooms" placeholder="2 Bathrooms" onChange={this.handleBathChange.bind(this)}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-5 col-sm-12 col-xs-12">
                                                <div class="form-group">
                                                    <label for="square_footage">Square Footage</label>
                                                    <input type="number" class="form-control" value={sqft} name="square_footage" placeholder="1145" onChange={this.handleSqftChange.bind(this)}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="header" style={{marginLeft: "-15px"}}>
                                                <h4 class="title">Quickbooks Integration</h4>
                                                <p class="category"></p>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <label for="custom_reference">Customer Name</label>
                                                        <input type="text" class="form-control" name="custom_reference" placeholder="Internal Company ID" id="ref_id" value={qb_custom_ref_id} onChange={this.handleRefIdChange.bind(this)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="header" style={{marginLeft: "-15px"}}>
                                                <h4 class="title">Owner</h4>
                                                <p class="category"></p>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <OwnersSelect columnSize={0} sortID={owner} title="Select an owner" onChange={this.handleOwnerChange.bind(this)}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="header">
                                    <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle" style={{paddingTop:"4px"}}><i class="icon-picture"></i></span> Photos</h4>
                                    <p class="category">Upload Property Cover Photo</p>
                                    <p class="category">Max size: 5 MB</p>
                                </div>
                                {!newProp && (
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="content">
                                            { image }
                                        </div>
                                    </div>
                                </div>
                                )}
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="content">
                                        { this.state.dropZoneSetup !== undefined && (
                                            <DropzoneComponent config={this.state.dropZoneConfig}
                                                eventHandlers={this.state.dropZoneEventHandlers}
                                                djsConfig={this.state.dropZoneJSConfig} />
                                        )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="header">
                                    <h4 class="title"><i class="pe-7s-cash"></i> Fees</h4>
                                    <p class="category">Any fees added will automatically be included on invoices and expenses related to this property.</p>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="content">
                                            { feeDetails != null && (
                                                <span>
                                                <p>Amount: <b>${feeDetails.fee_amount / 100}</b></p>
                                                <p>Percentage: <b>{feeDetails.fee_percentage}%</b></p>
                                                </span>
                                            )}
                                            <FeesSelect columnSize={0} sortID={fee} title="" onChange={this.handleFeeChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { user.userInfo != null && user.userInfo.user_type_alias == 'admin' && (
                <div class="col-md-4">
                    <div class="card">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="header">
                                    <h4 class="title"><i class="pe-7s-piggy"></i> Bank Account</h4>
                                    <p class="category">Select a bank account you'd like to collect rent from on this property.  If you leave this blank, we'll use the primary bank account.</p>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="content">
                                            <BankAccountSelect columnSize={0} sortID={bank_identifier} title="" onChange={this.handleBankChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                )}
                { singleUnit == false && (
                <div class="col-md-12">
                    <div class="card">
                        <div class="row">
                            <Modal
                                isOpen={this.state.showModal}
                                onRequestClose={this.handleCloseModal.bind(this)}
                                style={modalStyles.getModalStyles()}
                                ariaHideApp={false}
                            >
                            <div class="row">
                                <div class="modal-exit-icon pull-right" onClick={this.handleCloseModal.bind(this)}></div>
                            </div>
                            {newUnit == true ? (
                                <div class="row">
                                    <div class="modal-header">Add a Unit</div>
                                </div>
                            ) : (
                                <div class="row">
                                    <div class="modal-header">{unitName}</div>
                                </div>
                            )}
                            <div class="row">
                                <div class="modal-section-title col-md-5">Unit Information</div>
                            </div>
                            <form>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Unit Name*</label>
                                            <input type="text" value={unitName} class="form-control" name="unit_name" placeholder="Unit 101" id="unit_name" onChange={this.handleUnitNameChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Square Footage</label>
                                            <input type="number" value={unitSqft} class="form-control" name="unit_sqfootage" placeholder="1200" id="unit_sqfootage" onChange={this.handleUnitSqFootageChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Bedrooms</label>
                                            <input type="text" value={unitBed} class="form-control" name="unit_bedrooms" id="unit_bedrooms" onChange={this.handleUnitBedroomsChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Bathrooms</label>
                                            <input type="text" value={unitBath} class="form-control" name="unit_bathrooms" id="unit_bathrooms" onChange={this.handleUnitBathroomsChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                {/* <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="invoice-description">Upload Listing Photos</label>
                                            <textarea rows="10" cols="80" class="form-control" value="COMING SOON" readOnly/>
                                        </div>
                                    </div>
                                </div> */}
                                <div class="row">
                                    <div class="content">
                                    { newUnit === true ? (
                                    <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-3">
                                        <button type="button" id="add-unit" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.handleCreateUnit.bind(this)}>
                                            Create Unit
                                        </button>
                                    </div>
                                    ) : (
                                    <div class="col-md-12">
                                        <div class="col-md-3 col-md-offset-2 col-sm-3 col-sm-offset-2 col-xs-3">
                                            <button type="button" id="delete-unit" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.handleDeleteUnit.bind(this)}>
                                                Delete Unit
                                            </button>
                                        </div>
                                        <div class="col-md-3 col-md-offset-1 col-sm-3 col-sm-offset-1 col-xs-3 col-xs-offset-3">
                                            <button type="button" id="update-unit" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.handleSaveUnit.bind(this)}>
                                                Update Unit
                                            </button>
                                        </div>
                                    </div>
                                    )}
                                    <div class="clearfix"></div>
                                    </div>
                                </div>
                            </form>
                            </Modal>
                            <div class="col-md-12">
                                <div class="header">
                                    <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle" style={{paddingTop:"4px"}}><i class="icon-unit-box"></i></span> Units</h4>
                                    <p class="category">List of all units at the property</p>
                                </div>
                            </div>
                        </div>
                        <div class="content">
                            {totalUnits.length > 0 ? (
                            <div>
                                {window.innerWidth < 992 ? (
                                <BootstrapTable data={totalUnits} version='4' striped search pagination hover options={options}>
                                    <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                    <TableHeaderColumn dataField='name' dataSort={ true }>Title</TableHeaderColumn>
                                </BootstrapTable>
                                ) : (
                                <BootstrapTable data={totalUnits} version='4' striped search pagination hover options={options}>
                                    <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                    <TableHeaderColumn dataField='unit_name' dataSort={ true }>Title</TableHeaderColumn>
                                    <TableHeaderColumn dataField='bed' dataSort={ true }>Bed</TableHeaderColumn>
                                    <TableHeaderColumn dataField='bath' dataSort={ true }>Bath</TableHeaderColumn>
                                    <TableHeaderColumn dataField='sqft' dataSort={ true }>SQ Footage</TableHeaderColumn>
                                    <TableHeaderColumn dataField='contract_id' dataFormat={this.formatLease.bind(this.stopSelectRow)} dataSort={ true }>Lease</TableHeaderColumn>
                                    {/* <TableHeaderColumn dataField='' dataSort={ true }>Lease Status</TableHeaderColumn> */}
                                    {/* <TableHeaderColumn dataField='' dataSort={ true }>Photos</TableHeaderColumn> */}
                                </BootstrapTable>
                                )}
                                <button type="button" id="add_unit" autoComplete="off" class="btn btn-secondary btn-info btn-fill pull-right" onClick={this.handleOpenModal.bind(this, "add_unit")}>
                                    Add Unit
                                </button>
                                <div class="clearfix"></div>
                            </div>
                            ) : (
                            <div style={{textAlign: "center"}}>
                                <div class="row">
                                    <div class="main-page-header-row col-md-12">
                                        <div class="row" style={{marginTop: "10px"}}>
                                            <span class="main-page-header-title no-units-message">No Units Yet</span>
                                        </div>
                                        <div class="row" style={{marginTop: "10px"}}>
                                            <button type="button" id="add_unit" autoComplete="off" class="btn btn-secondary btn-info btn-fill" onClick={this.handleOpenModal.bind(this, "add_unit")}>
                                                Add Unit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                    </div>
                </div>
                )}
            </div>
            <div class="row blue-bottom">
                {( hasChangedUnit && !newProp ) && (
                <div class="row col-md-10" style={{color: "white", textAlign: "center", fontSize: "16px"}}>
                    {/* <b><i>***You have unsaved changes to the unit(s) info. Click "Update Property" to save!</i></b> */}
                </div>
                )}
                <div class="blue-bottom-center-align">
                    { newProp ? (
                        <button type="button" id="save-property" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.handleSavePropertyData.bind(this)}>
                        Create Property
                        </button>
                    ) : (
                        <div>
                        <div class="col-md-6 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                            <button type="button" id="delete-property" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.deleteProperty.bind(this)}>
                            Delete Property
                            </button>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <button type="button" id="save-property" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.updateProperty.bind(this)}>
                            Update Property
                            </button>
                        </div>
                        </div>
                    )}
                    <div class="clearfix"></div>
                </div>
            </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// app/components/Properties/PropertyEdit.jsx